import { render, staticRenderFns } from "./EdiTemplate.vue?vue&type=template&id=ca219e30&lang=pug"
import script from "./EdiTemplate.vue?vue&type=script&lang=js"
export * from "./EdiTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports